// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { DeliberateErrorKaboomGetData, DeliberateErrorKaboomGetResponses, GetSegmentDescriptionData, GetSegmentDescriptionErrors, GetSegmentDescriptionResponses, GetSegmentMappingRecommendationsData, GetSegmentMappingRecommendationsErrors, GetSegmentMappingRecommendationsResponses, HealthCheckHealthyGetData, HealthCheckHealthyGetResponses, InitialiseSegmentDescriptionRequestData, InitialiseSegmentDescriptionRequestErrors, InitialiseSegmentDescriptionRequestInternalData, InitialiseSegmentDescriptionRequestInternalErrors, InitialiseSegmentDescriptionRequestInternalResponses, InitialiseSegmentDescriptionRequestResponses, InitialiseSegmentMappingRequestData, InitialiseSegmentMappingRequestErrors, InitialiseSegmentMappingRequestInternalData, InitialiseSegmentMappingRequestInternalErrors, InitialiseSegmentMappingRequestInternalResponses, InitialiseSegmentMappingRequestResponses, PollWorkerRequestData, PollWorkerRequestErrors, PollWorkerRequestResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

export class TaxonomyService {
    /**
     * Init Request
     */
    public static initialiseSegmentMappingRequest<ThrowOnError extends boolean = true>(options: Options<InitialiseSegmentMappingRequestData, ThrowOnError>): RequestResult<InitialiseSegmentMappingRequestResponses, InitialiseSegmentMappingRequestErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<InitialiseSegmentMappingRequestResponses, InitialiseSegmentMappingRequestErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy/segment_mappings',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Init Request Internal
     */
    public static initialiseSegmentMappingRequestInternal<ThrowOnError extends boolean = true>(options: Options<InitialiseSegmentMappingRequestInternalData, ThrowOnError>): RequestResult<InitialiseSegmentMappingRequestInternalResponses, InitialiseSegmentMappingRequestInternalErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<InitialiseSegmentMappingRequestInternalResponses, InitialiseSegmentMappingRequestInternalErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            url: '/api/v1/taxonomy/segment_mappings/internal',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Recommendations
     */
    public static getSegmentMappingRecommendations<ThrowOnError extends boolean = true>(options: Options<GetSegmentMappingRecommendationsData, ThrowOnError>): RequestResult<GetSegmentMappingRecommendationsResponses, GetSegmentMappingRecommendationsErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetSegmentMappingRecommendationsResponses, GetSegmentMappingRecommendationsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/taxonomy/segment_mappings/{entity_id}/{segment_id}',
            ...options
        });
    }
}

export class ResultsService {
    /**
     * Poll Request
     */
    public static pollWorkerRequest<ThrowOnError extends boolean = true>(options: Options<PollWorkerRequestData, ThrowOnError>): RequestResult<PollWorkerRequestResponses, PollWorkerRequestErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<PollWorkerRequestResponses, PollWorkerRequestErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/results/{result_id}',
            ...options
        });
    }
}

export class EntityKnowledgeBaseService {
    /**
     * Init Request
     */
    public static initialiseSegmentDescriptionRequest<ThrowOnError extends boolean = true>(options: Options<InitialiseSegmentDescriptionRequestData, ThrowOnError>): RequestResult<InitialiseSegmentDescriptionRequestResponses, InitialiseSegmentDescriptionRequestErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<InitialiseSegmentDescriptionRequestResponses, InitialiseSegmentDescriptionRequestErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entity_knowledge_base/segment_descriptions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Init Request Internal
     */
    public static initialiseSegmentDescriptionRequestInternal<ThrowOnError extends boolean = true>(options: Options<InitialiseSegmentDescriptionRequestInternalData, ThrowOnError>): RequestResult<InitialiseSegmentDescriptionRequestInternalResponses, InitialiseSegmentDescriptionRequestInternalErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<InitialiseSegmentDescriptionRequestInternalResponses, InitialiseSegmentDescriptionRequestInternalErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            url: '/api/v1/entity_knowledge_base/segment_descriptions/internal',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Description
     */
    public static getSegmentDescription<ThrowOnError extends boolean = true>(options: Options<GetSegmentDescriptionData, ThrowOnError>): RequestResult<GetSegmentDescriptionResponses, GetSegmentDescriptionErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetSegmentDescriptionResponses, GetSegmentDescriptionErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/entity_knowledge_base/segment_descriptions/{entity_id}/{segment_id}',
            ...options
        });
    }
}

export class DefaultService {
    /**
     * Health Check
     */
    public static healthCheckHealthyGet<ThrowOnError extends boolean = true>(options?: Options<HealthCheckHealthyGetData, ThrowOnError>): RequestResult<HealthCheckHealthyGetResponses, unknown, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<HealthCheckHealthyGetResponses, unknown, ThrowOnError, 'data'>({
            responseStyle: 'data',
            url: '/healthy',
            ...options
        });
    }
    
    /**
     * Deliberate Error
     */
    public static deliberateErrorKaboomGet<ThrowOnError extends boolean = true>(options?: Options<DeliberateErrorKaboomGetData, ThrowOnError>): RequestResult<DeliberateErrorKaboomGetResponses, unknown, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<DeliberateErrorKaboomGetResponses, unknown, ThrowOnError, 'data'>({
            responseStyle: 'data',
            url: '/kaboom',
            ...options
        });
    }
}
